// src/data/clothingProductData.js

const clothingProductData = {
  product: {
    id: "BRZ-2025-001",
    brand: "Breezaya",
    title: "Floral Print Puff Sleeve Square-Neck Midi Dress with Slit",
    fullTitle:
      "Breezaya Floral Print Puff Sleeve Square-Neck Midi Dress with Slit",
    price: 11.62,
    originalPrice: 19.99,
    discount: 42,
    savingAmount: 8.37,
    currency: "USD",

    shipping: {
      isFree: true,
      minOrderForFree: 29,
      estimatedDelivery: { from: "Apr 21", to: "Apr 25" },
      region: "United Kingdom",
    },

    club: {
      name: "Agro CLUB",
      memberDiscount: 0.47,
      joinUrl: "/join-club",
    },

    gallery: [
      "https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?w=600&q=80",
      "https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=600&q=80",
      "https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=600&q=80",
      "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=600&q=80",
      "https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=600&q=80",
    ],

    colors: [
      {
        id: "c1",
        name: "White Floral",
        image: "https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?w=500&q=80",
        thumbnail: "https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?w=80&q=80",
      },
      {
        id: "c2",
        name: "Blue Floral",
        image: "https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=500&q=80",
        thumbnail: "https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=80&q=80",
      },
      {
        id: "c3",
        name: "Pink Floral",
        image: "https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=500&q=80",
        thumbnail: "https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=80&q=80",
      },
      {
        id: "c4",
        name: "Yellow",
        image: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=500&q=80",
        thumbnail: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=80&q=80",
      },
      {
        id: "c5",
        name: "Green",
        image: "https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=500&q=80",
        thumbnail: "https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=80&q=80",
      },
    ],

    sizes: [
      { label: "4 XS",   available: true  },
      { label: "6 S",    available: true  },
      { label: "8 S",    available: true  },
      { label: "10 M",   available: true  },
      { label: "12 L",   available: true  },
      { label: "14 XL",  available: true  },
      { label: "16 XXL", available: false },
    ],

    description:
      "Floral Print · Puff Sleeve · Square Neck · Side Slit · A-Line silhouette. Lightweight chiffon fabric.",

    model: {
      wearing: "S",
      height:  "5'9\"",
      bust:    "33\"",
      waist:   "24\"",
      hips:    "35\"",
    },

    features: [
      "Floral Print",
      "Puff Sleeve",
      "Square Neck",
      "Side Slit",
      "A-Line Silhouette",
      "Lightweight Chiffon",
    ],

    badges: {
      freeShipping:  true,
      freeReturns:   true,
      securePayment: true,
      totalSold:     50000,
    },

    returnPolicy: { days: 35, description: "No questions asked" },

    breadcrumb: ["Home", "Women", "Dresses", "Midi Dresses", "Floral Puff Sleeve"],
  },

  reviews: {
    averageRating:    4.86,
    totalReviews:     1000,
    displayedReviews: 42,
    ratingBreakdown:  { 5: 35, 4: 5, 3: 1, 2: 0, 1: 1 },
    fitTags: [
      { label: "Good Fit",     count: 34 },
      { label: "Runs Small",   count: 5  },
      { label: "Larger",       count: 2  },
      { label: "True to Size", count: 1  },
    ],
    items: [
      {
        id:           "r1",
        name:         "Sarah M.",
        rating:       5,
        date:         "Mar 12, 2025",
        tag:          "Good Fit",
        text:         "wasn't expecting to be this happy about this dress. It's so pretty. I'm between size S and M, look 5.4 fit great even if you are big or small chested you can adjust it with these strings. 10/10",
        image:        "https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=80&q=80",
        helpfulCount: 34,
        verified:     true,
      },
      {
        id:           "r2",
        name:         "Rachel K.",
        rating:       4,
        date:         "Feb 28, 2025",
        tag:          "True to Size",
        text:         "Love the floral print! Fits true to size. The puff sleeves are adorable and the fabric feels light and flowy. Highly recommend!",
        image:        null,
        helpfulCount: 12,
        verified:     true,
      },
      {
        id:           "r3",
        name:         "Priya D.",
        rating:       5,
        date:         "Jan 15, 2025",
        tag:          "Good Fit",
        text:         "Absolutely stunning dress. Perfect for summer events. The quality surprised me for the price!",
        image:        null,
        helpfulCount: 8,
        verified:     true,
      },
    ],
  },

  similarProducts: [
    {
      sectionId:    "super_deals",
      sectionTitle: "Super Deals",
      emoji:        "🔥",
      items: [
        { id: "sd1", name: "Crop Tank",     price: 4.9, originalPrice: 9.9,  discount: "50%", image: "https://images.unsplash.com/photo-1509631179647-0177331693ae?w=120&q=80" },
        { id: "sd2", name: "Mini Skirt",    price: 8.0, originalPrice: 15,   discount: "47%", image: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f?w=120&q=80" },
        { id: "sd3", name: "Floral Blouse", price: 11,  originalPrice: 22,   discount: "50%", image: "https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=120&q=80" },
        { id: "sd4", name: "Boho Dress",    price: 13,  originalPrice: 25,   discount: "48%", image: "https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=120&q=80" },
      ],
    },
    {
      sectionId:    "top_trends",
      sectionTitle: "Top Trends",
      emoji:        "✨",
      items: [
        { id: "tt1", name: "Midi Dress",    price: 15, originalPrice: 28, discount: "46%", image: "https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=120&q=80" },
        { id: "tt2", name: "Wrap Dress",    price: 13, originalPrice: 24, discount: "45%", image: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=120&q=80" },
        { id: "tt3", name: "Puff Sleeve",   price: 17, originalPrice: 30, discount: "43%", image: "https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?w=120&q=80" },
        { id: "tt4", name: "Pleated Midi",  price: 21, originalPrice: 38, discount: "44%", image: "https://images.unsplash.com/photo-1434389677669-e08b4cac3105?w=120&q=80" },
      ],
    },
    {
      sectionId:    "brand_zone",
      sectionTitle: "Brand Zone",
      emoji:        "🏷️",
      items: [
        { id: "bz1", name: "Perfume Set", price: 61, originalPrice: 95,  discount: "35%", image: "https://images.unsplash.com/photo-1585386959984-a4155224a1ad?w=120&q=80" },
        { id: "bz2", name: "Handbag",     price: 45, originalPrice: 75,  discount: "40%", image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=120&q=80" },
        { id: "bz3", name: "Sneakers",    price: 39, originalPrice: 65,  discount: "40%", image: "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=120&q=80" },
        { id: "bz4", name: "Watch",       price: 88, originalPrice: 140, discount: "37%", image: "https://images.unsplash.com/photo-1523293182086-7651a899d37f?w=120&q=80" },
      ],
    },
  ],
};

export default clothingProductData;

export const { product }         = clothingProductData;
export const { reviews }         = clothingProductData;
export const { similarProducts } = clothingProductData;